import React from 'react';
import styled from "@emotion/styled";
import dimensions from 'styles/dimensions';
import { Inner, gridColumns } from 'styles/structure';
import { Rubric } from 'styles/typography';
import CardSolution from 'components/CardSolution';
import Content from 'components/_ui/Content';

const FeatureContainer = styled.div`
  padding: 8rem 0 5.6rem;
  
  header {
    margin-bottom: 1.6rem;
    text-align: center;
    
    div {
      & + * {
        max-width: 96rem;
        margin: 2.4rem auto 0;
      }
    }
  }
  
  @media(min-width: ${dimensions.tabletLandscapeUp}px) {
    padding: 12rem 0 14.4rem;
    
    &.FeatureSolutions--solution {
      header {
        text-align: left;
        display: flex;
        justify-content: space-between;
        
        div {
          flex: 1 1 50%;
          
          & + * {
            margin-top: 0;
            margin-left: 5.6vw;
          }
        }
      }
    }
    
    header {
      margin-bottom: 9.6rem;
    }
  }
`;

const FeatureList = styled.ul`
  li {
    & + * {
      margin-top: 3.2rem;
    }
  }
  
  @media(min-width: ${dimensions.tabletLandscapeUp}px) {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    
    li {
      ${gridColumns('1/3', 3.2)}
      
      margin-right: 3.2rem;
      
      &:nth-of-type(3n),
      &:last-of-type {
        margin-right: 0;
      }
      
      & + * {
        margin-top: 0;
      }
      
      &:nth-of-type(n+4) {
        margin-top: 3.2rem;
      }
    }
  }
`;

const FeatureSolutions = ({ intro, heading, content, solutions, variant }) => {
  return (
    <FeatureContainer className={`${variant ? `FeatureSolutions--${variant}` : ''}`}>
      <Inner>
        <header>
          <div>
            {intro && <Rubric>{ intro }</Rubric>}
            {heading && <h2>{heading}</h2>}
          </div>

          {content && <Content content={content}/>}
        </header>

        <FeatureList>
          {solutions.map((solution, i) => (
            <li key={i}>
              <CardSolution
                destination={solution.destination}
                image={solution.image}
                illustration={solution.illustration}
                name={solution.name}
                text={solution.text}
              />
            </li>
          ))}
        </FeatureList>
      </Inner>
    </FeatureContainer>
  );
};

export default FeatureSolutions;
